import {SimpleGrid, Stack, StackProps} from "@chakra-ui/react";
import {HoverMenuItem, HoverMenuItemHeading, HoverMenuItemText, HoverMenuList} from "../components/HoverMenu";

const About = (props: StackProps) => (
  <HoverMenuList {...props}>
    <SimpleGrid gap={6}>
      <HoverMenuItem px={6} py={2} className="group">
        <Stack gap={1}>
          <HoverMenuItemHeading to="/about">About</HoverMenuItemHeading>
          <HoverMenuItemText>Learn about our mission, values &amp; team</HoverMenuItemText>
        </Stack>
      </HoverMenuItem>
      <HoverMenuItem px={6} py={2} className="group">
        <Stack gap={1}>
          <HoverMenuItemHeading to="https://trust.platformed.com/platformed">Trust Center</HoverMenuItemHeading>
          <HoverMenuItemText>Our approach to security, privacy &amp; trust</HoverMenuItemText>
        </Stack>
      </HoverMenuItem>
      <HoverMenuItem px={6} py={2} className="group">
        <Stack gap={1}>
          <HoverMenuItemHeading to="/careers">Careers</HoverMenuItemHeading>
          <HoverMenuItemText>Join the Platformed team</HoverMenuItemText>
        </Stack>
      </HoverMenuItem>
    </SimpleGrid>
  </HoverMenuList>
);
export default About;
